export enum SkaEventName {
  OpenProductDetails = 'open_product_details',
  AddToCart = 'add_to_cart',
  AddToWishList = 'add_favourites',
  RemoveFromWishList = 'remove_favourites',
  ViewItemList = 'view_item_list',
  PageView = 'page_view',
}

export interface ProductDetail {
  category: string;
  currency: string;
  id: string;
  item_brand: string;
  item_category: string;
  item_id: string;
  item_name: string;
  item_variant?: string;
  user_input: string;
  finish: string;
  price?: number;
}

export interface Payload {
  page_title?: string;
  textValue?: string;
  isBrandSpecificSA?: boolean;
  isMobileApp?: boolean;
  items: ProductDetail[];
}

export interface SkaTrackingEvent {
  payload: SkaTrackingEventPayload;
}

export interface SkaTrackingEventPayload {
  name: string;
  payload: Payload & ProductDetail;
}
